import { network } from 'services/network';

import { ISetNotificationsReadStatusPayload } from 'components/App/AuthenticateLayout/Header/Notification/Notifications.types';

export const setListReadStatus = (params: ISetNotificationsReadStatusPayload) => {
    return params.consumer_email
        ? network.post('api/bo/notification/setListReadStatus', params).then((response) => response.data)
        : Promise.reject();
};
